/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../helpers'
import { useLayout } from '../../../layout/core'
import { axiosClientAuth } from '../../../../app/utils/axiosClient';

const DrawerBulkIP: FC = () => {
  const { currentBulkData } = useLayout();
  const [detail, setDetail] = useState<any>(null);

  useEffect(() => {
    if (!currentBulkData?.id) return;
    setDetail(null);
    axiosClientAuth.get('/ip/bulk-upload/batches/' + currentBulkData.id + '/').then(resp => {
      setDetail(resp.data?.data);
    }).catch(err => {
      console.log(err);
    });
  }, [currentBulkData?.id]);

  return (
    <div
      id='kt_drawer_bulk_ip'
      className='bg-white'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_drawer_bulk_ip_toggle'
      data-kt-drawer-close='#kt_drawer_bulk_ip_close'
    >
      <div className='card w-100 rounded-0' id='kt_drawer_bulk_ip_messenger'>
        <div className='card-header pe-5' id='kt_drawer_bulk_ip_messenger_header'>
          <div className='card-title'>
            <div className='d-flex justify-content-center flex-column me-3'>
              <a href='#' className='fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                {currentBulkData?.filename}
              </a>

              <div className='mb-0 lh-1'>
                <span className='fs-7 fw-semibold text-gray-400'>{currentBulkData?.ip_count} IPs</span>
              </div>
            </div>
          </div>

          <div className='card-toolbar'>
            {/* <div className='me-2'>
              <button
                className='btn btn-sm btn-icon btn-active-light-primary'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <i className='bi bi-three-dots fs-3'></i>
              </button>
            </div> */}

            <div className='btn btn-sm btn-icon btn-active-light-primary' id='kt_drawer_bulk_ip_close'>
              <KTIcon iconName='cross' className='fs-2' />
            </div>
          </div>
        </div>

        <div className='card-body'>
          {!detail ? (
            <div className='d-flex justify-content-center align-items-center py-10'>
              <span className='text-muted fw-semibold'>Loading...</span>
            </div>
          ) : (
            <div className='timeline'>
              {detail.addresses?.map((ip: string, index: number) => (
                <div key={index} className='timeline-item mb-4'>
                  <div className='timeline-line w-40px'></div>
                  <div className='timeline-icon symbol symbol-circle symbol-40px me-4'>
                    <div className='symbol-label bg-light-primary'>
                      <KTIcon iconName='geolocation' className='fs-2 text-primary' />
                    </div>
                  </div>
                  <div className='timeline-content mt-2'>
                    <div className='fs-5 fw-bold'>{ip}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  )
}

export { DrawerBulkIP }